export interface Video {
  id: number;
  title: string;
  description: string;
  category: string;
  thumbnail: string;
  duration: string;
  year: number;
  rating: number;
  views: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  updateInfo: string;
  director: string;
  cast: string[];
}

export const videos: Video[] = [
  {
    id: 1,
    title: '星辰大海',
    description: '一部讲述现代都市年轻人追梦故事的励志剧集。主人公从一个小城市来到大都市，在职场与情感中不断成长，最终找到了属于自己的一片天空。全剧制作精良，演员阵容强大，剧情紧凑引人入胜。',
    category: 'drama',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20drama%20series%20poster%20with%20city%20skyline%20at%20night%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20professional%20Asian%20actors%20in%20modern%20attire%2C%20emotional%20atmosphere%2C%20film%20grain%20texture%2C%20clean%20background%20with%20bokeh%20city%20lights&width=640&height=360&seq=xk-video-01&orientation=landscape',
    duration: '45分钟/集',
    year: 2025,
    rating: 9.2,
    views: '1280万',
    tags: ['都市', '励志', '情感', '职场'],
    isHot: true,
    isNew: false,
    updateInfo: '更新至36集',
    director: '张明远',
    cast: ['李星辰', '王雨晴', '赵天宇', '陈思琪'],
  },
  {
    id: 2,
    title: '暗夜追踪',
    description: '悬疑犯罪题材力作，讲述刑侦队长与犯罪心理专家联手破获连环案件的故事。剧情环环相扣，反转不断，每一集都让人欲罢不能。',
    category: 'drama',
    thumbnail: 'https://readdy.ai/api/search-image?query=Suspense%20crime%20thriller%20Chinese%20drama%20poster%20with%20dark%20alley%20and%20neon%20lights%2C%20mysterious%20atmosphere%2C%20detective%20silhouette%2C%20rainy%20night%20scene%2C%20cinematic%20noir%20style%2C%20film%20poster%20quality&width=640&height=360&seq=xk-video-02&orientation=landscape',
    duration: '42分钟/集',
    year: 2025,
    rating: 9.5,
    views: '2560万',
    tags: ['悬疑', '犯罪', '推理', '刑侦'],
    isHot: true,
    isNew: true,
    updateInfo: '更新至24集',
    director: '刘思远',
    cast: ['周明哲', '林小雨', '陈伟霆', '张静初'],
  },
  {
    id: 3,
    title: '山河锦绣',
    description: '大型历史古装剧，讲述乱世中英雄儿女保家卫国的传奇故事。场景宏大，服化道精美，堪称年度古装剧标杆之作。',
    category: 'drama',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20costume%20drama%20poster%20with%20ancient%20Chinese%20architecture%20and%20mountains%2C%20warriors%20in%20traditional%20armor%2C%20golden%20sunset%20lighting%2C%20grand%20cinematic%20scale%2C%20artistic%20illustration%20style&width=640&height=360&seq=xk-video-03&orientation=landscape',
    duration: '50分钟/集',
    year: 2024,
    rating: 8.9,
    views: '1890万',
    tags: ['古装', '历史', '战争', '传奇'],
    isHot: false,
    isNew: false,
    updateInfo: '全48集',
    director: '陈国栋',
    cast: ['吴天昊', '杨紫嫣', '刘奕君', '赵丽蓉'],
  },
  {
    id: 4,
    title: '极速风暴',
    description: '赛车题材热血电影，讲述一位草根车手逆袭成为冠军的励志故事。真实赛道拍摄，震撼的赛车场面，带你体验速度与激情。',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Action%20racing%20movie%20poster%20with%20fast%20sports%20cars%20on%20track%2C%20dramatic%20motion%20blur%2C%20sunset%20sky%2C%20intense%20atmosphere%2C%20cinematic%20movie%20poster%20quality%2C%20warm%20color%20grading&width=640&height=360&seq=xk-video-04&orientation=landscape',
    duration: '118分钟',
    year: 2025,
    rating: 8.7,
    views: '980万',
    tags: ['动作', '赛车', '励志', '热血'],
    isHot: true,
    isNew: true,
    updateInfo: '高清完整版',
    director: '韩峰',
    cast: ['彭一博', '黄景行', '王一诺'],
  },
  {
    id: 5,
    title: '深海迷踪',
    description: '科幻冒险电影，一支深海探险队在万米深海发现了一个惊天秘密。视觉效果震撼，剧情跌宕起伏，年度必看科幻大片。',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Science%20fiction%20deep%20sea%20exploration%20movie%20poster%20with%20mysterious%20underwater%20scene%2C%20bioluminescent%20creatures%2C%20dark%20blue%20ocean%20depths%2C%20submarine%20lights%2C%20cinematic%20quality%2C%20atmospheric&width=640&height=360&seq=xk-video-05&orientation=landscape',
    duration: '135分钟',
    year: 2025,
    rating: 9.0,
    views: '1560万',
    tags: ['科幻', '冒险', '深海', '悬疑'],
    isHot: true,
    isNew: false,
    updateInfo: '4K超清版本',
    director: '马浩然',
    cast: ['吴京腾', '李一峰', '张雪迎'],
  },
  {
    id: 6,
    title: '欢乐家族',
    description: '爆笑家庭喜剧，讲述四世同堂的一大家子啼笑皆非的日常生活。金句频出，笑料不断，适合全家一起观看的欢乐剧集。',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Funny%20Chinese%20family%20comedy%20show%20poster%20with%20colorful%20bright%20living%20room%20scene%2C%20happy%20family%20group%2C%20warm%20lighting%2C%20playful%20atmosphere%2C%20TV%20show%20style%2C%20clean%20composition&width=640&height=360&seq=xk-video-06&orientation=landscape',
    duration: '60分钟/期',
    year: 2025,
    rating: 8.5,
    views: '3200万',
    tags: ['喜剧', '家庭', '搞笑', '综艺'],
    isHot: false,
    isNew: true,
    updateInfo: '更新至第12期',
    director: '王笑天',
    cast: ['沈腾飞', '贾琳琳', '宋小宝', '马丽'],
  },
  {
    id: 7,
    title: '剑道苍穹',
    description: '国产热血动漫，讲述少年剑客在修仙世界历经磨难最终成为剑道至尊的故事。画面精美，打斗场面燃爆，国漫崛起之作。',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20martial%20arts%20fantasy%20poster%20with%20swordsman%20in%20ancient%20Chinese%20style%2C%20dynamic%20action%20pose%2C%20glowing%20energy%20effects%2C%20mountain%20landscape%20background%2C%20vibrant%20colors%2C%20anime%20illustration%20style&width=640&height=360&seq=xk-video-07&orientation=landscape',
    duration: '22分钟/集',
    year: 2025,
    rating: 9.4,
    views: '4500万',
    tags: ['国漫', '修仙', '热血', '战斗'],
    isHot: true,
    isNew: true,
    updateInfo: '更新至52集',
    director: '林动',
    cast: ['配音：张杰', '配音：季冠霖'],
  },
  {
    id: 8,
    title: '地球脉动·亚洲篇',
    description: '大型自然纪录片，深入亚洲各地拍摄珍稀野生动物和壮美自然景观。每一帧都是壁纸级别，带你领略大自然的鬼斧神工。',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20stunning%20Asian%20landscape%20mountains%20and%20wildlife%2C%20sunrise%20golden%20light%2C%20majestic%20scenery%2C%20professional%20wildlife%20photography%20quality%2C%20clean%20natural%20aesthetic&width=640&height=360&seq=xk-video-08&orientation=landscape',
    duration: '50分钟/集',
    year: 2024,
    rating: 9.7,
    views: '890万',
    tags: ['自然', '纪录片', '动物', '地理'],
    isHot: false,
    isNew: false,
    updateInfo: '全6集',
    director: '陈晓卿',
    cast: ['旁白：濮存昕'],
  },
  {
    id: 9,
    title: '青春不散场',
    description: '校园青春电影，讲述高中时代一群好友的欢笑与泪水。纯真的友谊、懵懂的爱情，带你重回那个最美好的年纪。',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20youth%20campus%20movie%20poster%20with%20students%20in%20school%20uniform%20under%20cherry%20blossom%20trees%2C%20sunlight%20filtering%20through%2C%20nostalgic%20warm%20tone%2C%20clean%20aesthetic%2C%20cinematic%20quality&width=640&height=360&seq=xk-video-09&orientation=landscape',
    duration: '108分钟',
    year: 2025,
    rating: 8.8,
    views: '1350万',
    tags: ['青春', '校园', '友情', '爱情'],
    isHot: false,
    isNew: true,
    updateInfo: '高清完整版',
    director: '何一凡',
    cast: ['易烊千玺', '周冬雨', '刘浩然'],
  },
  {
    id: 10,
    title: '食遍天下',
    description: '美食探索纪录片，跟随主持人走遍中国各地，探寻最地道的美食文化。从街头小吃到宫廷大菜，每一集都是一场味蕾的盛宴。',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20delicious%20traditional%20Chinese%20cuisine%20dishes%2C%20warm%20restaurant%20lighting%2C%20steaming%20hot%20food%2C%20appetizing%20colors%2C%20clean%20food%20photography%20style&width=640&height=360&seq=xk-video-10&orientation=landscape',
    duration: '35分钟/集',
    year: 2025,
    rating: 9.1,
    views: '2100万',
    tags: ['美食', '旅行', '文化', '纪录片'],
    isHot: true,
    isNew: false,
    updateInfo: '更新至18集',
    director: '蔡澜生',
    cast: ['主持：黄小厨'],
  },
  {
    id: 11,
    title: '天籁之声·第五季',
    description: '华语乐坛顶级音乐竞技节目，实力唱将同台比拼，用歌声诠释音乐的力量。本季赛制全面升级，精彩程度翻倍。',
    category: 'music',
    thumbnail: 'https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20with%20spotlight%20stage%2C%20microphone%2C%20colorful%20lighting%20effects%2C%20concert%20atmosphere%2C%20dramatic%20stage%20design%2C%20professional%20performance%20photography&width=640&height=360&seq=xk-video-11&orientation=landscape',
    duration: '90分钟/期',
    year: 2025,
    rating: 8.6,
    views: '5600万',
    tags: ['音乐', '竞技', '歌唱', '综艺'],
    isHot: true,
    isNew: true,
    updateInfo: '更新至第8期',
    director: '洪涛',
    cast: ['导师：刘欢', '导师：那英', '导师：周杰伦'],
  },
  {
    id: 12,
    title: '萌宠乐园',
    description: '专为小朋友打造的少儿节目，可爱的动画角色带领孩子们探索世界、学习知识。寓教于乐，安全健康的内容让家长放心。',
    category: 'kids',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cute%20children%20animated%20show%20poster%20with%20colorful%20cartoon%20animals%2C%20bright%20happy%20style%2C%20playful%20design%2C%20educational%20theme%2C%20soft%20pastel%20colors%2C%20clean%20illustration&width=640&height=360&seq=xk-video-12&orientation=landscape',
    duration: '15分钟/集',
    year: 2025,
    rating: 9.3,
    views: '1800万',
    tags: ['少儿', '动画', '教育', '启蒙'],
    isHot: false,
    isNew: false,
    updateInfo: '更新至86集',
    director: '阳光工作室',
    cast: ['配音：月亮姐姐', '配音：太阳哥哥'],
  },
];

export const getVideosByCategory = (categorySlug: string): Video[] => {
  return videos.filter((v) => v.category === categorySlug);
};

export const getVideoById = (id: number): Video | undefined => {
  return videos.find((v) => v.id === id);
};

export const getHotVideos = (): Video[] => {
  return videos.filter((v) => v.isHot);
};

export const getNewVideos = (): Video[] => {
  return videos.filter((v) => v.isNew);
};

export const getRelatedVideos = (video: Video, count: number = 4): Video[] => {
  return videos
    .filter((v) => v.id !== video.id && v.category === video.category)
    .slice(0, count);
};